// extracted by mini-css-extract-plugin
module.exports = {"sectionHeader":"PrintSectionHeader_sectionHeader__2sIdo"};